// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_AuthorizationProvider.proto

export enum ENUM_AuthorizationProvider {
  AUTHORIZATION_PROVIDER_UNSPECIFIED = 'AUTHORIZATION_PROVIDER_UNSPECIFIED',
  AUTHORIZATION_PROVIDER_GOOGLE = 'AUTHORIZATION_PROVIDER_GOOGLE',
  AUTHORIZATION_PROVIDER_MAB = 'AUTHORIZATION_PROVIDER_MAB',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
